import englishTranslationContent from './english-translation';
import chineseTranslationContent from './chinese-translation';
import thaiTranslationContent from './thai-translation';
const translation = locale => {
  const englishTranslation = englishTranslationContent();
  const chineseTranslation = chineseTranslationContent();
  const thaiTranslation = thaiTranslationContent();
  return {
    locale: locale,
    fallbackLocale: 'en',
    messages: {
      en: englishTranslation,
      zh: chineseTranslation,
      th: thaiTranslation,
    },
  };
};

export default translation;
